import { Button } from 'react-bootstrap'
import { X } from 'lucide-react'

export default function CrossButton(props) {

    const { onClick, disabled } = props

    return (
        <>
            <Button
                type='button'
                variant='light'
                size='sm'
                onClick={onClick}
                disabled={disabled}
            >
                <X size={14} style={{ marginBottom: '2px' }} className='text-secondary' />
            </Button>
        </>
    )
}